/**
 * Who enters a league (BUG-28): teams, individual players (singles) or
 * two-player pairs (doubles). Mirrors leagues.participant_format on the
 * backend (see backend/src/services/league/leagueParticipants.js).
 */

export const PARTICIPANT_FORMATS = {
  TEAM: 'team',
  INDIVIDUAL: 'individual',
  PAIR: 'pair',
};

/** The league's participant format and the words the UI uses for an entry. */
export const getLeagueFormat = (league) => {
  const raw = league?.participant_format;
  const format = Object.values(PARTICIPANT_FORMATS).includes(raw) ? raw : PARTICIPANT_FORMATS.TEAM;
  const isSingles = format === PARTICIPANT_FORMATS.INDIVIDUAL;
  const isDoubles = format === PARTICIPANT_FORMATS.PAIR;
  const unit = isSingles ? 'Player' : isDoubles ? 'Pair' : 'Team';
  return {
    format,
    isSingles,
    isDoubles,
    isTeam: !isSingles && !isDoubles,
    unit,
    unitPlural: `${unit}s`,
    unitLower: unit.toLowerCase(),
  };
};

/**
 * The id the schedule and match APIs use for an entry: teams.id for team and
 * pair entries, the entry's own id for an individual player.
 */
export const entryKey = (entry) => entry?.team_id ?? entry?.id;

/** Is this user already playing in the league (as a player or a pair member)? */
export const isUserEntered = (entries, userId) =>
  (entries || []).some((e) =>
    Number(e.user_id) === Number(userId) ||
    (Array.isArray(e.member_user_ids) && e.member_user_ids.map(Number).includes(Number(userId))));

/** The play-format help text shown on the league forms. */
export const playFormatHelp = (playFormat) =>
  playFormat === 'singles'
    ? 'Players join individually and each match is one player against another.'
    : 'Players join as a pair of two and each match is one pair against another.';
